<template>
  <v-autocomplete
    :value="value"
    @input="handleInput"
    :items="languages"
    :rules="rules"
    placeholder="Search languages..."
    item-text="label"
    item-value="value"
    :label="label"
    :required="required"
    multiple
    chips
    small-chips
    deletable-chips
  ></v-autocomplete>
</template>

<script>
import { languages } from "@/services/services";
export default {
  name: "LanguagesSelect",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: "Languages",
    },
    required: {
      type: Boolean,
      default: true,
    },
    onChange: {
      type: Function,
      default: null,
    },
  },
  computed: {
    languages: () => languages,
  },
  data() {
    return {};
  },
  methods: {
    handleInput(selectedValues) {
      this.$emit("input", selectedValues);
      if (this.onChange && typeof this.onChange === "function") {
        this.onChange(selectedValues);
      }
    },
  },
};
</script>
